.reactionList {
  margin-top: var(--ant-margin-xxs);
}

.reactionChip {
  font-size: var(--ant-font-size);
}

/* Border and tint instead of a primary button, which would vanish below the primary-coloured owner bubble */
.reactionChipMine {
  border-color: var(--ant-color-primary);
  background-color: var(--ant-color-primary-bg);
}

/* Touch screens get the same 44px targets as the comment action links */
@media (pointer: coarse) {
  .reactionChip {
    min-width: 44px;
    min-height: 44px;
  }
}
